import type { Message } from '../types';

const toValidDateOrUndefined = (value: unknown): Date | undefined => {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? undefined : value;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
  }

  return undefined;
};

type MessageUpdate = Partial<Message> & {
  id: string;
  conversationId: string;
};

export const mergeMessageUpdate = (existing: Message, update: MessageUpdate): Message => {
  const createdAt = toValidDateOrUndefined(update.createdAt) ?? existing.createdAt;
  const readAt =
    update.readAt === null ? null : toValidDateOrUndefined(update.readAt) ?? existing.readAt;

  return {
    ...existing,
    ...update,
    content: update.content ?? existing.content,
    senderId: update.senderId ?? existing.senderId,
    recipientId: update.recipientId ?? existing.recipientId,
    createdAt,
    readAt,
  };
};

